@if (updateAvailable$ | async) {
  <div>
    <span translate>update_toast.update-available</span>
    <span class="link" (click)="update()" translate>update_toast.update-now</span>
  </div>
}
